import { render, staticRenderFns } from "./documentTabs.vue?vue&type=template&id=f871935e"
import script from "./documentTabs.vue?vue&type=script&lang=js"
export * from "./documentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports